import React from "react";
import { Button } from "common/src/styles";
import useColorAndBackground from "../../hooks/attestations/useColorAndBackground";
import { ShareButtons } from "../common/ShareButtons";
import { useGetImages } from "../../hooks/attestations/useGetImages";
export const PreviewFrame = _ref => {
  let {
    handleSelectBackground,
    mint
  } = _ref;
  const {
    backgroundAlternatives,
    defaultColor,
    colorMapper,
    preview_alt1
  } = useColorAndBackground();
  const [selectedColor, setSelectedColor] = React.useState("0");
  const [previewBackground, setPreviewBackground] = React.useState(preview_alt1);
  function selectBackground(option) {
    setSelectedColor(option);
    setPreviewBackground(backgroundAlternatives[Number(option)]);
    handleSelectBackground(option);
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex flex-col w-auto items-center relative rounded-3xl",
      style: {
        backgroundImage: `url(${previewBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "690px",
        height: "344px"
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "flex flex-wrap gap-3 items-center mt-3   p-2",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col items-center",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-wrap items-center space-x-2 z-30 my-3",
          children: [/*#__PURE__*/_jsx("div", {
            className: "text-2xl font-modern-era-regular",
            children: "Pick your color"
          }), Object.keys(colorMapper).map((key, index) => /*#__PURE__*/_jsx("div", {
            onClick: () => selectBackground(key),
            className: `w-5 h-5 rounded-full cursor-pointer ${selectedColor === key ? "border-1 border-black" : ""}`,
            style: {
              backgroundColor: selectedColor === key ? colorMapper[key] : defaultColor
            }
          }, index))]
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-2 z-40",
          children: /*#__PURE__*/_jsx("div", {
            className: `flex align-center justify-center border-[1px] rounded-[8px] bg-rainbow-gradient border-transparent`,
            children: /*#__PURE__*/_jsx(Button, {
              type: "button",
              className: `px-10 py-1 rounded-[8px] bg-white font-medium font-mono text-base text-black h-8 whitespace-nowrap border-[2px] border-transparent hover:shadow-md`,
              onClick: mint,
              "data-testid": "mint-donation-button",
              children: "Mint donation"
            })
          })
        })]
      })
    })]
  });
};
export const PreviewFrameHistoryPage = _ref2 => {
  let {
    nextStep,
    selectBackground,
    previewBackground,
    selectedColor
  } = _ref2;
  const {
    defaultColor,
    colorMapper
  } = useColorAndBackground();
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center gap-2 sm:gap-6",
    children: [/*#__PURE__*/_jsx("img", {
      className: "w-full max-w-[600px] min-w-[287px]",
      src: previewBackground,
      alt: "preview"
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-wrap items-center space-x-2 z-30",
      children: [/*#__PURE__*/_jsx("div", {
        className: "text-lg font-modern-era-regular",
        children: "Pick your color"
      }), Object.keys(colorMapper).map((key, index) => {
        const isSelected = selectedColor === index.toString();
        return /*#__PURE__*/_jsx("div", {
          onClick: () => selectBackground(key),
          className: `size-5 rounded-full cursor-pointer ${isSelected ? "border border-[#555555] bg-[${colorMapper[key as unknown as keyof typeof colorMapper]}]" : `bg-[${defaultColor}]`}`,
          style: {
            backgroundColor: isSelected ? colorMapper[key] : defaultColor
          }
        }, index);
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: `flex align-center justify-center border-[1px] rounded-[8px] bg-rainbow-gradient border-transparent`,
      children: /*#__PURE__*/_jsx(Button, {
        type: "button",
        className: `px-4 py-1 rounded-[8px] bg-white font-medium font-mono text-base text-black h-12 sm:h-8 whitespace-nowrap border-transparent hover:shadow-md`,
        onClick: nextStep,
        "data-testid": "mint-donation-button",
        children: "Mint your donation"
      })
    })]
  });
};
import { ImageWithLoading } from "../common/components/ImageWithLoading";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ImpactMintingSuccess = _ref3 => {
  let {
    attestationLink,
    impactImageCid,
    imageSize = "w-full max-w-[700px] relative",
    isShareButtonsAbove = true
  } = _ref3;
  const {
    data: image,
    isLoading,
    isFetching
  } = useGetImages(impactImageCid ? [impactImageCid] : [], !!impactImageCid);
  return isShareButtonsAbove ? /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center gap-6",
    children: [/*#__PURE__*/_jsx(ShareButtons, {
      attestationLink: attestationLink,
      isTop: isShareButtonsAbove
    }), /*#__PURE__*/_jsx(ImageWithLoading, {
      src: image === null || image === void 0 ? void 0 : image[0],
      isLoading: isLoading || !image || !impactImageCid || isFetching,
      sizeClass: imageSize
    })]
  }) : /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center gap-6",
    children: [/*#__PURE__*/_jsx(ImageWithLoading, {
      src: image === null || image === void 0 ? void 0 : image[0],
      isLoading: isLoading || !image || !impactImageCid || isFetching,
      sizeClass: imageSize
    }), /*#__PURE__*/_jsx(ShareButtons, {
      attestationLink: attestationLink,
      isTop: isShareButtonsAbove
    })]
  });
};